module.exports = __webpack_public_path__ + "static/STG20_Desktop_2880_Module5_Drink1_Royal-01a489c96c44cafe071dda8967e410b2.png";